<template>
  <div class="home">
    <!-- Banner -->

    <!-- Conent section -->
    <ContentSection v-if="theme.name != undefined" :theme="theme" />
  </div>
</template>

<script>
//import Banner from "../components/search-components/Banner";
import ContentSection from "../components/theme-components/ContentSection";

export default {
  name: "Home",
  components: {
    //Banner,
    ContentSection,
  },
  data() {
    return {
      theme: {},
    };
  },
  methods: {
    getTheme: function() {
      this.$axios
        .get(`themes/${this.$route.params.theme}`)
        .then((res) => {
          if (res.data.theme != null && res.data.theme.id != null) {
            this.theme = res.data.theme;
          } else {
            this.$router.push("/");
          }
        });
    },
  },
  mounted() {
    console.log(this.$route.params);

    this.getTheme();
  },
};
</script>
